import React from "react";
import { NavigationalButtons } from "./CreateCourseWizard";
import { Form, Formik } from "formik";
import StepsList from "../Steps/StepsList";

const StepsStep = ({ courseId, revId, nextOnClick, prevOnClick, setup }) => {

    return (
        <div>
            <StepsList crsId={courseId} revId={revId} setup={setup} />
            <Formik
                initialValues={{}}
                onSubmit={async () => {
                    nextOnClick();
                }}
            >
                <Form>
                    <NavigationalButtons
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default StepsStep;
